import * as React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import AdminAuditorManager from './feature/AdminAuditorManager';
import Page from './Page';




const AuditFirmManagement = () => {
    return (
        <Page>
            <Row>
                <Col sm="12">
                    <Card body style={{ height: "50em" }} >
                        <AdminAuditorManager />
                    </Card>
                </Col>
            </Row>
        </Page>
    );
}
export default AuditFirmManagement;